import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";

const OPTS = [["ms", "Bahasa Melayu"], ["en", "English"]];

export const DocLanguageBar = ({ meetingId, kind, doc, canWrite, onTranslated }) => {
  const { L } = useApp();
  const [busy, setBusy] = useState("");
  const current = doc?.output_language || "ms";
  const translate = async (target) => {
    if (target === current || busy) return;
    setBusy(target);
    try {
      const { data } = await api.post(`/meetings/${meetingId}/documents/${kind}/translate`, { target });
      onTranslated(data);
      toast.success(L("Dokumen diterjemah", "Document translated"));
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy("");
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3" data-testid="doc-language-bar">
      <span className="flex items-center gap-2 text-sm font-semibold text-slate-700"><Languages size={16} className="text-violet-600" /> {L("Bahasa dokumen", "Document language")}</span>
      <div className="flex rounded-xl border border-slate-200 p-0.5">
        {OPTS.map(([k, label]) => (
          <button key={k} type="button" disabled={!canWrite || !!busy} onClick={() => translate(k)} aria-pressed={current === k} data-testid={`doc-lang-${k}`}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${current === k ? "bg-violet-600 text-white" : "text-slate-600 hover:bg-slate-100"} disabled:cursor-not-allowed`}>
            {busy === k && <Loader2 size={12} className="animate-spin" />}{label}
          </button>
        ))}
      </div>
      <span className="text-xs text-slate-500">{busy ? L("Menterjemah… (kira-kira 20–40 saat)", "Translating… (about 20–40 s)") : L("Terjemah terus dokumen ini · guna 1 kuota jana dokumen", "Translate this document directly · uses 1 document generation")}</span>
    </div>
  );
};
